import React from "react";
import { Alert, Form, Icon, Button, Select, Row, Col, DatePicker } from "antd";
import get from "lodash/get";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router";

import { endOfStudyLogRequest } from "../../api/requests";

import {
  getDelegationLogAdminCreatePermission,
  getDelegationLogAdminUpdatePermission,
} from "../../reducers/user/selectors";

import { logout } from "../../reducers/user/actions";
import classes from "./DelegationLogs.css";
import moment from "moment";

class EndOfStudyForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        const data = {
          end_of_study_date: values.end_of_study_datetime.format("YYYY-MM-DDT12:00"),
        };

        try {
          await endOfStudyLogRequest({
            id: this.props.delegationLog.id,
            data,
          });

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            this.props.onSubmit();
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", "Error"),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { delegationLogAdminCreatePermission } = this.props;

    const isEditable = delegationLogAdminCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t(
              "NamespaceDelegationLogs:Start End of Study"
            )}
          </h4>

          <Row gutter={12}>
            <Col>
              <label>
                <b>{this.props.i18n.t("End of study date")}</b>
                <Form.Item>
                  {getFieldDecorator("end_of_study_datetime", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(
                      this.props,
                      "delegationLog.end_of_study_datetime"
                    )
                      ? moment(
                          get(this.props, "delegationLog.end_of_study_datetime")
                        )
                      : null,
                  })(
                    <DatePicker
                      disabled={!isEditable}
                      placeholder="yyyy-mm-dd"
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                loading={isLoading}
                className={classes.submitButton}
              >
                {this.props.i18n.t("Save")}
              </Button>
            )}
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  delegationLogAdminCreatePermission: getDelegationLogAdminCreatePermission(
    state
  ),
  delegationLogAdminUpdatePermission: getDelegationLogAdminUpdatePermission(
    state
  ),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "EndOfStudyForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(withNamespaces()(EndOfStudyForm)))
);



// WEBPACK FOOTER //
// ./src/containers/DelegationLogs/EndOfStudyForm.js